module.exports = {
	"locales": [
		"it"
	],
	"messages": {
		"App": {
			"title": "L'ennesima applicazione revenge"
		},
		"Hello": {
			"hello": "ciao"
		},
		"Login": {
			"login": "Login",
			"username": "nome utente",
			"password": "password",
			"error": "errore",
			"processing": "login in corso"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/locales/it.json
// module id = 371
// module chunks = 0